<template>
  <div class="affirm">
    <common-layout>
      <div slot="header">
        <div class="affirm_tabs">
          <span
            v-for="btn in tabs"
            :key="btn.id"
            @click="handleClick(btn.id)"
            :class="{'active_t':activeName== btn.id}"
          >{{btn.name}}</span>
        </div>
        <div class="back">
          <el-button
            type="warning"
            @click="back"
          >返回上一页</el-button>
        </div>
      </div>
      <div slot="container">
        <!-- 个人认证 -->
        <el-form
          key="ruleForm"
          v-if="activeName == 1"
          ref="ruleForm"
          :model="ruleForm"
          label-width="150px"
          class="ruleForm"
        >
          <div class="ruleForm-title">
            <h4></h4>
            <span>个人认证信息</span>
            <span
              v-if="ruleForm.is_validate == 2"
              class="label"
            >(已认证)</span>
            <span
              v-else
              class="label2"
            >(未认证)</span>
          </div>

          <el-row style="width:46%;margin-bottom:0;">
            <el-form-item
              label="姓名"
              prop="name"
            >
              <el-input
                v-model="ruleForm.name"
                placeholder="请填写姓名"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证"
              prop="idCard"
            >
              <el-input
                v-model="ruleForm.idCard"
                placeholder="请填写身份证"
                disabled
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row style="margin-top:0;">
            <el-form-item
              label="所在地"
              prop="detailed"
              style="text-align:left;"
            >
              <v-distpicker
                @selected="citySelected"
                :province="ruleForm.address.province.value"
                :city="ruleForm.address.city.value"
                :area="ruleForm.address.area.value"
                disabled
              ></v-distpicker>
              <el-input
                style="margin-top:10px;width:37%"
                placeholder="请填写详细地址"
                v-model="ruleForm.detailed"
                disabled
              ></el-input>
            </el-form-item>
          </el-row>

          <!-- 个人认证 -->
          <div class="ruleForm-title">
            <h4></h4>
            <span>个人详细信息</span>
          </div>

          <el-row class="row-tow">
            <el-collapse
              v-model="activeNames"
              @change="handleChange"
            >
              <el-collapse-item :name="ruleForm.item.activeId">
                <template slot="title">
                  <div class="ruleForm-titles">
                    <p>我的团队</p>
                  </div>
                </template>
                <template>
                  <el-row>
                    <el-row style="margin:0">
                      <el-col :span="16">
                        <el-form-item
                          label="团队名称"
                          prop="team_name"
                        >
                          <el-input
                            v-model="ruleForm.team_name"
                            placeholder="请填写团队名称"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item
                          label="团队规模"
                          prop="team_scale"
                        >
                          <el-input
                            v-model="ruleForm.team_scale"
                            placeholder="请填写团队规模"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item
                      label="团队描述"
                      prop="team_description"
                    >
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 6 }"
                        placeholder="请输入您的描述信息..."
                        v-model="ruleForm.team_description"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-row>
                </template>
              </el-collapse-item>

              <el-collapse-item :name="ruleForm.expert.activeId">
                <template slot="title">
                  <div class="ruleForm-titles">
                    <p>我是专家</p>
                  </div>
                </template>
                <template>
                  <el-row>
                    <el-row style="margin:0">
                      <el-col :span="12">
                        <el-form-item
                          label="行政职务"
                          prop="expert_position"
                        >
                          <el-input
                            v-model="ruleForm.expert.expert_position"
                            placeholder="请填写行政职务"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="行政级别"
                          prop="expert_level"
                        >
                          <el-input
                            v-model="ruleForm.expert_level"
                            placeholder="请填写行政级别"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row style="margin:0">
                      <el-col :span="12">
                        <el-form-item
                          label="在职状态"
                          prop="expert_incumbency"
                        >
                          <el-input
                            v-model="ruleForm.expert_incumbency"
                            placeholder="请填写在职状态"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="从业工龄"
                          prop="expert_work"
                          style="text-align:left;"
                        >
                          <el-input
                            v-model="ruleForm.expert_work"
                            placeholder="请填写在职状态"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row style="margin:0">
                      <el-col :span="12">
                        <el-form-item
                          label="专业技术职称"
                          prop="expert_title"
                        >
                          <el-input
                            v-model="ruleForm.expert_title"
                            placeholder="请填写专业技术职称"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="主要研究方向"
                          prop="expert_research"
                        >
                          <el-input
                            v-model="ruleForm.expert_research"
                            placeholder="请填写研究方向"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item
                      label="取得时间"
                      prop="expert_time"
                      style="text-align:left;"
                    >
                      <el-date-picker
                        v-model="ruleForm.expert_time"
                        type="year"
                        placeholder="请选择"
                        format="yyyy 年"
                        style="width:100%;"
                        disabled
                      ></el-date-picker>
                      <a style="margin-right:10px" :href="item.url" target="_blank" v-for="(item,index) in ruleForm.expert_image" :key="index">{{item.name}}</a>
                      <!-- <commonUpload
                        @successUp="successUp"
                        @removeUp="removeUp"
                        :inputValue="'ruleForm.expert_image'"
                        :txt="'上传证明'"
                      ></commonUpload>-->
                    </el-form-item>
                    <el-form-item
                      label="从业经历"
                      prop="expert_experience"
                    >
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 6 }"
                        placeholder="描述您的从业经历..."
                        v-model="ruleForm.expert_experience"
                        disabled
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="主要成就"
                      prop="expert_archive"
                    >
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 6 }"
                        placeholder="描述您的主要成就..."
                        v-model="ruleForm.expert_archive"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-row>
                </template>
              </el-collapse-item>

              <el-collapse-item :name="ruleForm.mentors.activeId">
                <template slot="title">
                  <div class="ruleForm-titles">
                    <p>我是创业导师</p>
                  </div>
                </template>
                <template>
                  <el-row>
                    <el-row style="margin:0">
                      <el-col :span="12">
                        <el-form-item
                          label="行政职务"
                          prop="mentors_position"
                        >
                          <el-input
                            v-model="ruleForm.mentors_position"
                            placeholder="请填写行政职务"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="行政级别"
                          prop="mentors_level"
                        >
                          <el-input
                            v-model="ruleForm.mentors_level"
                            placeholder="请填写行政级别"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row style="margin:0">
                      <el-col :span="12">
                        <el-form-item
                          label="在职状态"
                          prop="mentors_incumbency"
                        >
                          <el-input
                            v-model="ruleForm.mentors_incumbency"
                            placeholder="请填写在职状态"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="从业工龄"
                          prop="mentors_work"
                          style="text-align:left;"
                        >
                          <el-input
                            v-model="ruleForm.mentors_work"
                            placeholder="请填写行政级别"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item
                      label="专业技术职称"
                      prop="mentors_title"
                    >
                      <el-input
                        v-model="ruleForm.mentors_title"
                        placeholder="请填写专业技术职称"
                        disabled
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="取得时间"
                      prop="mentors_time"
                      style="text-align:left;"
                    >
                      <el-date-picker
                        v-model="ruleForm.mentors_time"
                        type="year"
                        placeholder="请选择"
                        format="yyyy 年"
                        style="width:100%;"
                        disabled
                      ></el-date-picker>
                      <!-- <commonUpload
                        @successUp="successUp"
                        @removeUp="removeUp"
                        :inputValue="'ruleForm.mentors_image'"
                        :txt="'上传证明'"
                      ></commonUpload>-->
                      <a style="margin-right:10px" :href="item.url" target="_blank" v-for="(item,index) in ruleForm.mentors_image" :key="index">{{item.name}}</a>
                    </el-form-item>
                    <el-form-item
                      label="从业经历"
                      prop="mentors_experience"
                    >
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 6 }"
                        placeholder="描述您的从业经历..."
                        v-model="ruleForm.mentors_experience"
                        disabled
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="主要成就"
                      prop="mentors_archive"
                    >
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 6 }"
                        placeholder="描述您的主要成就..."
                        v-model="ruleForm.mentors_archive"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-row>
                </template>
              </el-collapse-item>
            </el-collapse>
          </el-row>

          <!-- <div class="ruleForm-title">
            <h4></h4>
            <span>认证结果</span>
          </div>
          <el-row class="row-tow">
            <el-form-item label="认证结果">
              <el-select
                v-model="ruleForm.is_validate"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入备注..."
                v-model="ruleForm.remarks"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-form-item class="subBt">
            <el-button @click="onSubmit">提交</el-button>
          </el-form-item> -->
        </el-form>

        <!-- 企业认证 -->
        <el-form
          v-else
          key="CompanyForm"
          :model="CompanyForm"
          status-icon
          ref="CompanyForm"
          label-width="150px"
          class="ruleForm fromTwo"
        >
          <div class="ruleForm-title">
            <h4></h4>
            <span>企业认证信息</span>
            <span
              v-if="CompanyForm.is_validate == 2"
              class="label"
            >(已认证)</span>
            <span
              v-else
              class="label2"
            >(未认证)</span>
          </div>

          <el-row class="comRow">
            <el-form-item
              label="组织机构名称"
              prop="company"
            >
              <el-input
                v-model="CompanyForm.company"
                placeholder="请填写组织机构名称"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="统一社会信用代码"
              prop="creditno"
            >
              <el-input
                v-model="CompanyForm.creditno"
                placeholder="请填写统一社会信用代码"
                disabled
              ></el-input>
              <!-- <commonUpload
                @successUp="successUp"
                @removeUp="removeUp"
                :inputValue="'ruleForm.expert.fileList'"
                :txt="'上传营业执照'"
                :listType="'picture'"
              ></commonUpload>-->
            </el-form-item>
            <el-form-item label='营业执照'>
              <img
                v-for="(item,index) in CompanyForm.company_image"
                :key="index"
                :src="item.url"
              />
            </el-form-item>
            <el-form-item
              label="法人代表人"
              prop="company_person"
              style="text-align:left;"
            >
              <el-input
                v-model="CompanyForm.company_person"
                placeholder="请填写法人代表人"
                disabled
              ></el-input>
              <!-- <commonUpload
                @successUp="successUp"
                @removeUp="removeUp"
                :inputValue="'ruleForm.expert.fileList'"
                :txt="'上传法人身份证'"
                :listType="'picture'"
              ></commonUpload>-->
            </el-form-item>
            <el-form-item label='法人身份证'>
              <img
                v-for="(item,index) in CompanyForm.company_person_image"
                :key="index"
                :src="item.url"
              />
            </el-form-item>
            <el-form-item
              label="单位住所"
              prop="company_address"
              style="text-align:left;"
            >
              <el-col>
                <v-distpicker
                  @selected="citySelected"
                  :province="CompanyForm.company_address.province.value"
                  :city="CompanyForm.company_address.city.value"
                  :area="CompanyForm.company_address.area.value"
                  disabled
                ></v-distpicker>
              </el-col>
              <el-col style="margin-top:10px;">
                <el-input
                  v-model="CompanyForm.detailed"
                  placeholder="请填写详细地址"
                  disabled
                ></el-input>
              </el-col>
            </el-form-item>
            <el-row style="margin:0">
              <el-col :span="12">
                <el-form-item
                  label="成立日期"
                  prop="company_day"
                  style="text-align:left;"
                >
                  <el-date-picker
                    v-model="CompanyForm.company_day"
                    type="year"
                    placeholder="请选择"
                    format="yyyy 年"
                    value-format="yyyy 年"
                    style="width:100%;"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="单位规模"
                  prop="company_scale"
                  style="text-align:left;"
                >
                  <el-select
                    v-model="CompanyForm.company_scale"
                    placeholder="请选择"
                    style="width:100%;"
                    clearable
                    disabled
                  >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              label="单位及项目介绍"
              prop="company_introduction"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入内容"
                v-model="CompanyForm.company_introduction"
                disabled
              ></el-input>
            </el-form-item>
          </el-row>

          <div class="ruleForm-title">
            <h4></h4>
            <span>企业详细信息</span>
          </div>

          <el-row class="comRow">
            <el-form-item label="关注领域">
              <el-input
                placeholder="请输入内容"
                v-model="CompanyForm.company_domain"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="相关资质"
              prop="company_natural"
            >
             <a style="margin-right:10px" :href="item.url" target="_blank" v-for="(item,index) in CompanyForm.company_natural" :key="index">{{item.name}}</a>
              <!-- <commonUpload
                style="margin-top:0"
                @successUp="successUp"
                @removeUp="removeUp"
                :inputValue="'CompanyForm.company_natural'"
                :txt="'上传证明'"
              ></commonUpload> -->
            </el-form-item>
            <el-form-item
              label="服务内容"
              prop="company_service"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入内容"
                v-model="CompanyForm.company_service"
                disabled
              ></el-input>
              <a style="margin-right:10px" :href="item.url" target="_blank" v-for="(item,index) in CompanyForm.company_enclosure" :key="index">{{item.name}}</a>
              <!-- <commonUpload
                @successUp="successUp"
                @removeUp="removeUp"
                :inputValue="'ruleForm.company_enclosure'"
                :txt="'上传附件材料'"
              ></commonUpload>-->
            </el-form-item>
          </el-row>

          <!-- <div class="ruleForm-title">
            <h4></h4>
            <span>认证结果</span>
          </div>
          <el-row class="row-tow">
            <el-form-item label="认证结果">
              <el-select
                v-model="CompanyForm.is_validate"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入备注..."
                v-model="ruleForm.remarks"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-form-item class="subBt">
            <el-button @click="onSubmit">提交</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </common-layout>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../components/common-layout.vue";
import { isNull } from 'util';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      checkList: [
        {
          id: '001',
          name: '新能源'
        },
        // {
        //   id: '002',
        //   name: '清洁生产'
        // },
        // {
        //   id: '003',
        //   name: '清洁能源'
        // },
        {
          id: '004',
          name: '现代农业'
        },
        {
          id: '005',
          name: '生物医药'
        },
        {
          id: '006',
          name: '文化旅游'
        },
        {
          id: '007',
          name: '通道物流'
        },
        {
          id: '008',
          name: '军民融合'
        },
        {
          id: '009',
          name: '数据信息'
        },
        {
          id: '010',
          name: '装备制造'
        },
        {
          id: '011',
          name: '新材料'
        }
        // {
        //   id: "011",
        //   name: "文化旅游"
        // },
        // {
        //   id: "012",
        //   name: "通道物流"
        // },
      ],
      options: [
        {
          value: 1,
          label: "未通过"
        },
        {
          value: 2,
          label: "已通过"
        }
      ],
      options1: [
        {
          value: 1,
          label: "20人以内"
        },
        {
          value: 2,
          label: "21-50人"
        },
        {
          value: 3,
          label: "51-200人"
        },
        {
          value: 4,
          label: "201-500人"
        },
        {
          value: 5,
          label: "501-2000人"
        },
        {
          value: 6,
          label: "2001人以上"
        }
      ],
      activeName: 1,
      activeNames: ["1", "2", "3"],
      tabs: [
        {
          id: 1,
          name: "个人认证"
        },
        {
          id: 2,
          name: "企业认证"
        }
      ],
      ruleForm: {
        is_validate: "",
        idCard: "",
        address: {
          province: {
            value: ""
          },
          city: {
            value: ""
          },
          area: {
            value: ""
          }
        },
        detailed: "",
        name: "",
        team_name:'',
        team_description:'',
        team_scale:'',
        item: {
          activeId: "1",
          isShow: false,
        },
        expert_position:'',
        expert_level:'',
        expert_incumbency:'',
        expert_work:'',
        expert_title:'',
        expert_time:'',
        expert_image:[],
        expert_experience:'',
        expert_archive:'',
        expert: {
          activeId: "2",
          isShow: false,
        },
        mentors_position:'',
        mentors_level:'',
        mentors_incumbency:'',
        mentors_work:'',
        mentors_title:'',
        mentors_time:'',
        mentors_image:[],
        mentors_experience:'',
        mentors_archive:'',
        mentors: {
          activeId: "3",
          isShow: false,
        }
      },
      CompanyForm: {
        company: "",
        creditno: "",
        company_person: "",
        company_address: {
          province: {
            value: ""
          },
          city: {
            value: ""
          },
          area: {
            value: ""
          }
        },
        detailed: "",
        company_day: "",
        company_scale: "",
        company_introduction: "",
        company_domain:[],
        company_natural: [],
        company_enclosure: [],
        company_service: "",
        is_validate: "",
        company_image: [],
        company_person_image: []
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.http.get("User/" + this.$route.params.id).then(res => {
        if (res.code == 0) {
          this.ruleForm.name = res.data.name;
          this.ruleForm.is_validate = res.data.person_validate;
          this.ruleForm.idCard = res.data.id_card_number;
          if (res.data.address) {
            this.ruleForm.address = res.data.address;
            this.ruleForm.detailed = res.data.address.detailed;
          }
          this.ruleForm.team_name = res.data.team_name;
          this.ruleForm.team_description = res.data.team_description;
          this.ruleForm.team_scale = res.data.team_scale;
          this.ruleForm.expert_position = res.data.expert_position;
          this.ruleForm.expert_level = res.data.expert_level;
          this.ruleForm.expert_incumbency = res.data.expert_incumbency;
          this.ruleForm.expert_work = res.data.expert_work;
          this.ruleForm.expert_title = res.data.expert_title;
          this.ruleForm.expert_time = res.data.expert_time;
          if(res.data.expert_image){
            this.ruleForm.expert_image=[]
            res.data.expert_image.split(",").forEach((item,index) => {
              this.ruleForm.expert_image.push({
                name: "证明-" + index,
                url: this.imgUrl + item
              });
            });
          }
          this.ruleForm.expert_experience = res.data.expert_experience;
          this.ruleForm.expert_archive = res.data.expert_archive;
          this.ruleForm.mentors_position = res.data.mentors_position;
          this.ruleForm.mentors_level = res.data.mentors_level;
          this.ruleForm.mentors_incumbency = res.data.mentors_incumbency;
          this.ruleForm.mentors_work = res.data.mentors_work;
          this.ruleForm.mentors_title = res.data.mentors_title;
          this.ruleForm.mentors_time = res.data.mentors_time;
          if(res.data.mentors_image){
            this.ruleForm.mentors_image = []
            res.data.mentors_image.split(",").forEach((item,index) => {
              this.ruleForm.mentors_image.push({
                name: "证明-" + index,
                url: this.imgUrl + item
              });
            });
          }
          this.ruleForm.mentors_experience = res.data.mentors_experience;
          this.ruleForm.mentors_archive = res.data.mentors_archive;


          this.CompanyForm.company = res.data.company;
          this.CompanyForm.creditno = res.data.creditno;
          this.CompanyForm.is_validate = res.data.company_validate;
          this.CompanyForm.company_person = res.data.company_person;
          this.CompanyForm.company_day = res.data.company_day;
          this.CompanyForm.company_scale = res.data.company_scale;
          this.CompanyForm.company_introduction = res.data.company_introduction;
          if (res.data.company_image) {
            this.CompanyForm.company_image = []
            res.data.company_image.split(",").forEach(item => {
              this.CompanyForm.company_image.push({
                name: "营业执照",
                url: this.imgUrl + item
              });
            });
          }
          if (res.data.company_person_image) {
            this.CompanyForm.company_person_image=[]
            res.data.company_person_image.split(",").forEach(item => {
              this.CompanyForm.company_person_image.push({
                name: "身份证",
                url: this.imgUrl + item
              });
            });
          }
          if (res.data.company_address) {
            this.CompanyForm.company_address = res.data.company_address;
            this.CompanyForm.detailed = res.data.company_address.detailed;
          }
          if(res.data.company_domain){
            let arr = [];
            this.CompanyForm.company_domain = []
            res.data.company_domain.split(',').forEach(item=>{
              this.checkList.forEach(ele=>{
                if(item == ele.id){
                  arr.push(ele.name)
                }
              })
            })
            this.CompanyForm.company_domain = arr.join('、')
          }
          if (isNull(res.data.company_natural)) {
            this.CompanyForm.company_natural = []
          }else{
            this.CompanyForm.company_natural = []
            res.data.company_natural.split(",").forEach((item,index) => {
              this.CompanyForm.company_natural.push({
                name: "证明-" + index,
                url: this.imgUrl + item
              });
            });
          }
          if (isNull(res.data.company_enclosure)) {
            this.CompanyForm.company_enclosure = []
          }else{
            this.CompanyForm.company_enclosure = []
            res.data.company_enclosure.split(",").forEach((item,index) => {
              this.CompanyForm.company_enclosure.push({
                name: "材料-" + index,
                url: this.imgUrl + item
              });
            });
          }
          this.CompanyForm.company_service = res.data.company_service;
        }
      });
    },
    // 切换tab
    handleClick(val) {
      this.activeName = val;
      // if (val == 1) {
      //   this.getPer();
      // }
    },
    back() {
      this.$router.push("/user/examineRole");
    },
    citySelected(e) {},
    handleChange(e) {},
    onSubmit() {}
  }
};
</script>

<style scoped lang="scss">
.affirm {
  height: 100%;
  .back {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .affirm_tabs {
    width: 300px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
  .ruleForm {
    width: 900px;
    text-align: left;
    margin: 0 auto;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    /deep/.el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .ruleForm-title {
      width: 100%;
      display: flex;
      align-content: center;
      justify-content: flex-start;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      h4 {
        width: 20px;
        height: 28px;
        background: rgba(248, 84, 21, 1);
        margin: 0;
      }

      span {
        margin-left: 10px;
        color: #333333;
        display: flex;
        align-content: center;
        justify-content: center;
      }
      .label {
        color: #0e9d69;
      }
      .label2 {
        color: #999999;
      }
    }
    .el-row {
      margin: 35px 0;
    }
    .row-tow {
      margin: 35px auto;
    }
    .comRow {
      margin: 35px auto;
      /deep/.el-checkbox {
        /deep/.is-indeterminate {
          /deep/.el-checkbox__inner {
            background-color: #f85415;
            border-color: #f85415;
            &::before {
              top: 8px;
            }
          }
        }
        /deep/.is-focus {
          /deep/.el-checkbox__inner {
            border-color: #f85415;
          }
        }
        /deep/.el-checkbox__inner {
          &:hover {
            border-color: #f85415;
          }
        }
      }
      /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #f85415;
        border-color: #f85415;
      }
      /deep/.el-checkbox__inner {
        width: 20px;
        height: 20px;
        &::after {
          top: 4.5px;
          left: 6.5px;
        }
      }
      /deep/.el-checkbox__label {
        color: #333333;
      }
    }
    .ruleForm-titles {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #333333;
      font-size: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      padding: 0 20px;
      p {
        span {
          margin-left: 10px;
          color: #0e9d69;
        }
      }
      .title {
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #f85415;
          border-color: #f85415;
        }
        /deep/.el-checkbox__inner {
          width: 20px;
          height: 20px;
          &::after {
            top: 4.5px;
            left: 6.5px;
          }
        }
      }
    }
    .el-collapse {
      // width: 895px;
      /deep/.is-active {
        background: #f7f7f7;
      }
      /deep/.el-collapse-item__content {
        padding-bottom: 0;
      }
      /deep/.el-collapse-item__wrap {
        padding-right: 60px;
      }
    }
    .upload-demo {
      margin-top: 10px;
      /deep/.el-upload {
        /deep/.el-button {
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          background: rgba(66, 141, 255, 1);
          border-radius: 18px;
          padding: 10px 25px;
        }
      }
    }
    .subBt {
      /deep/.el-form-item__content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-left: 0 !important;
        .el-button {
          text-align: center;
          width: 160px;
          height: 50px;
          background: rgba(248, 84, 21, 1);
          border: 0px solid rgba(226, 226, 226, 1);
          border-radius: 30px;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    img {
      width: auto;
      height: 100px;
      margin-right: 20px;
      border-radius: 5px;
    }
  }
  .fromTwo {
    padding-right: 80px;
  }
}
</style>
